import { createRpcClientV2 } from 'rpc-client-utils';
import { listByPathRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemePresetRpc';
import { createRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ActiveThemePresetRpc';
import http from 'hub-http/clients/apiClient';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchPresets = themePath => rpcClient.call(listByPathRpc, {
  request: {
    path: themePath
  }
});
export const applyPreset = (themePath, activeThemePresetId) => rpcClient.call(createRpc, {
  request: {
    themePath,
    activeThemePresetType: 'CUSTOM',
    // hardcode for now
    activeThemePresetId
  }
});